import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { AUTH_TOKEN, REFRESH_TOKEN, USER_DATA } from "constants/AuthConstant"
import AuthService from "services/AuthService"

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  refresh: localStorage.getItem(REFRESH_TOKEN) || null,
  userData: localStorage.getItem(USER_DATA)
    ? JSON.parse(localStorage.getItem(USER_DATA))
    : {},
}

export const registerSchoolAdmin = createAsyncThunk(
  "auth/register",
  async (data, { rejectWithValue }) => {
    try {
      await AuthService.registerSchoolAdmin(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error")
    }
  },
)

export const signIn = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    const { email, password } = data
    try {
      const response = await AuthService.login({ email, password })
      const { token, refresh_token, adminSchool } = response.data
      localStorage.setItem(AUTH_TOKEN, token)
      localStorage.setItem(REFRESH_TOKEN, refresh_token)
      localStorage.setItem(USER_DATA, JSON.stringify(adminSchool))
      return {
        token,
        refresh_token,
        adminSchool,
      }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error")
    }
  },
)

export const refresh = createAsyncThunk(
  "auth/refresh",
  async (args, { rejectWithValue }) => {
    try {
      const refreshToken = localStorage.getItem(REFRESH_TOKEN)
      const response = await AuthService.refresh({ refreshToken })
      const newAccessToken = response.data.accessToken
      //   const rfToken = response.data.newRefreshToken;
      localStorage.setItem(AUTH_TOKEN, newAccessToken)
      //   localStorage.setItem(REFRESH_TOKEN, rfToken);

      return newAccessToken
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Erreur")
    }
  },
)

export const signInWithGoogle = createAsyncThunk(
  "auth/signInWithGoogle",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.loginInOAuth()
      const token = response.data.token
      const refresh_token = response.data.refresh_token
      localStorage.setItem(AUTH_TOKEN, token)
      localStorage.setItem(REFRESH_TOKEN, refresh_token)
      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error")
    }
  },
)
export const signInWithFacebook = createAsyncThunk(
  "auth/signInWithFacebook",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.loginInOAuth()
      const token = response.data.token
      const refresh_token = response.data.refresh_token
      localStorage.setItem(AUTH_TOKEN, token)
      localStorage.setItem(REFRESH_TOKEN, refresh_token)
      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error")
    }
  },
)

export const signOut = createAsyncThunk("auth/logout", async () => {
  localStorage.removeItem(AUTH_TOKEN)
  localStorage.removeItem(REFRESH_TOKEN)
  localStorage.removeItem(USER_DATA)
})

export const getUser = createAsyncThunk(
  "auth/currentUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.getUser()
      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data.message || "Erreur")
    }
  },
)

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false
      state.redirect = "/"
      state.token = action.payload
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload
      state.showMessage = true
      state.loading = false
    },
    hideAuthMessage: (state) => {
      state.message = ""
      state.showMessage = false
    },
    signOutSuccess: (state) => {
      state.loading = false
      state.token = null
      state.redirect = "/"
    },
    showLoading: (state) => {
      state.loading = true
    },
    signInSuccess: (state, action) => {
      state.loading = false
      state.token = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = "/"
        state.token = action.payload.token
        state.refresh = action.payload.refresh_token
        state.userData = action.payload.adminSchool
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false
        state.token = null
        state.redirect = "/"
        state.token = null
        state.refresh = null
        state.userData = {}
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false
        state.token = null
        state.redirect = "/"
      })
      .addCase(registerSchoolAdmin.pending, (state) => {
        state.loading = true
      })
      .addCase(registerSchoolAdmin.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(registerSchoolAdmin.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })

      .addCase(signInWithGoogle.pending, (state) => {
        state.loading = true
      })
      .addCase(signInWithGoogle.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = "/"
        state.token = action.payload
      })
      .addCase(signInWithGoogle.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(signInWithFacebook.pending, (state) => {
        state.loading = true
      })
      .addCase(signInWithFacebook.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = "/"
        state.token = action.payload
      })
      .addCase(signInWithFacebook.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(getUser.pending, (state) => {
        state.loading = true
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload
      })
      .addCase(getUser.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
  },
})

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
} = authSlice.actions

export default authSlice.reducer
